import React from 'react';
import { Quote, Star } from 'lucide-react';
import Reveal from './Reveal';

const testimonials = [
  {
    quote:
      'Freya went from a 5 to an 8 in Maths in two terms. What changed wasn’t more hours — it was finally having someone who could explain it the way she thinks.',
    name: 'Rachel D.',
    role: 'Parent, Year 11 · Manchester',
    initials: 'RD',
    tone: 'from-brand-500 to-brand-700',
  },
  {
    quote:
      'The recap after every lesson is the bit I didn’t know I needed. I can see exactly what my son covered and what he still can’t do.',
    name: 'Ade O.',
    role: 'Parent, Year 13 · London',
    initials: 'AO',
    tone: 'from-emerald-500 to-emerald-700',
  },
  {
    quote:
      'As a tutor the whiteboard is the reason I stayed. I can actually teach a proof instead of screen-sharing a PDF and hoping.',
    name: 'Priya S.',
    role: 'Tutor, Physics · Cambridge',
    initials: 'PS',
    tone: 'from-amber-400 to-amber-500',
  },
];

const Testimonials: React.FC = () => (
  <section className="section-shell py-20 sm:py-28">
    <Reveal className="max-w-2xl">
      <p className="eyebrow">Results</p>
      <h2 className="display mt-3 text-4xl text-balance sm:text-5xl">
        The grade goes up. So does the
        {' '}
        <span className="italic text-brand-600 dark:text-brand-400">confidence</span>
      </h2>
    </Reveal>

    <div className="mt-14 grid gap-5 lg:grid-cols-3">
      {testimonials.map((t, i) => (
        <Reveal key={t.name} delay={i * 0.09}>
          <figure className="surface flex h-full flex-col p-7 shadow-soft transition duration-300 hover:-translate-y-1 hover:shadow-lift">
            <Quote className="h-6 w-6 text-brand-500/30" />
            <blockquote className="mt-4 flex-1 text-[15px] leading-relaxed text-base-content/75">
              {t.quote}
            </blockquote>
            <div className="mt-4 flex items-center gap-0.5 text-amber-500">
              {[0, 1, 2, 3, 4].map((s) => (
                <Star key={s} className="h-3.5 w-3.5 fill-current" />
              ))}
            </div>
            <figcaption className="mt-5 flex items-center gap-3 border-t border-ink-900/[0.07] pt-5 dark:border-white/10">
              <span
                className={`grid h-10 w-10 shrink-0 place-items-center rounded-full bg-gradient-to-br ${t.tone} text-xs font-bold text-white`}
              >
                {t.initials}
              </span>
              <div className="min-w-0">
                <p className="truncate text-sm font-semibold">{t.name}</p>
                <p className="truncate text-xs text-base-content/55">{t.role}</p>
              </div>
            </figcaption>
          </figure>
        </Reveal>
      ))}
    </div>
  </section>
);

export default Testimonials;
